import React from 'react'
import { AuditOutlined } from '@ant-design/icons'
import { questionActions } from '../../../../../store/slices/question.slice'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import CompareWithLmsDrawer from './CompareWithLmsDrawer'
import questionSelectors from '../../../../../store/selectors/question.selectors'

const CompareWithLmsButton = () => {
    const showCompareWithLmsDrawer = useSelector(questionSelectors.showCompareWithLmsDrawer)
    const dispatch = useDispatch()

    return (
        <>
            <Button
                icon={<AuditOutlined aria-hidden='true' />}
                onClick={() => dispatch(questionActions.setShowCompareWithLmsDrawer(true))}
                type='text'
            >
                Compare with LMS
            </Button>
            {showCompareWithLmsDrawer && <CompareWithLmsDrawer />}
        </>
    )
}

export default CompareWithLmsButton
